import { useScrollReveal } from "@/hooks/useScrollReveal"

const purposes = [
  {
    emoji: "🌍",
    title: "Democratizar o inglês",
    description: "Tornar o aprendizado acessível, estruturado e possível para qualquer pessoa, sem barreiras artificiais, mensalidades inalcançáveis ou métodos que excluem quem tem pouco tempo.",
    highlight: "Inglês não pode ser elitizado.\nPrecisa ser aplicável à vida real.",
    color: "#B038B2",
  },
  {
    emoji: "⏳",
    title: "Respeitar a rotina real",
    description: "Criamos métodos pensados para adultos que trabalham, estudam, cuidam da família e não podem viver em função de aulas presenciais.",
    highlight: "Você aprende no seu ritmo.\nMas com direção, estrutura e acompanhamento.",
    color: "#0E8EA0",
  },
  {
    emoji: "🚀",
    title: "Gerar impacto real",
    description: "Não ensinamos inglês para acumular conteúdo.\nEnsinamos para destravar oportunidades.\nPara ampliar carreiras.\nPara abrir portas internacionais.\nPara dar segurança em entrevistas, viagens e reuniões.",
    highlight: "Porque aprender inglês é expandir possibilidades.",
    color: "#F5C542",
  },
]

export default function PurposeSection() {
  const { ref, isVisible } = useScrollReveal()

  return (
    <section id="proposito" className="py-20 md:py-28 bg-gray-50">
      <div ref={ref} className="max-w-7xl mx-auto px-5">
        <div
          className={`text-center mb-16 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-5">
            Nosso propósito é <span style={{ color: "#B038B2" }}>abrir portas.</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            Acreditamos que o inglês não deve ser privilégio — deve ser <strong className="text-gray-800">possibilidade</strong>.
          </p>
          <div className="w-20 h-1 rounded-full mx-auto mt-6" style={{ backgroundColor: "#0E8EA0" }} />
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {purposes.map((item, i) => (
            <div
              key={item.title}
              className={`bg-white rounded-2xl p-8 border-t-4 transition-all duration-500 hover:shadow-xl hover:-translate-y-1 flex flex-col ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
              }`}
              style={{
                borderTopColor: item.color,
                transitionDelay: isVisible ? `${(i + 1) * 150}ms` : "0ms",
              }}
            >
              <div className="text-4xl mb-5">{item.emoji}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{item.title}</h3>
              <p className="text-gray-500 text-base leading-relaxed mb-5 whitespace-pre-line">{item.description}</p>
              <div
                className="mt-auto border-l-4 pl-4 py-2 rounded-r-lg"
                style={{ borderLeftColor: item.color, backgroundColor: `${item.color}08` }}
              >
                <p className="text-gray-700 font-semibold text-sm leading-relaxed whitespace-pre-line">
                  {item.highlight}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
